import PropTypes from 'prop-types';
import { Link } from 'react-router';

import logo from '../../assets/images/logo.svg';
import styles from './styles/styles.module.css';

function Logo({ smallSize }) {
  return (
    <div className={styles.logoWrapper}>
      <Link to="https://ambar-sklad.ru/">
        <img
          src={logo}
          alt="логотип"
          className={`${styles.logo} ${smallSize ? styles.logo_small : ''}`}
        />
      </Link>
    </div>
  );
}

export default Logo;

Logo.propTypes = {
  smallSize: PropTypes.bool,
};
